export const RefinanceStatus = {
  AWAITING_FEEDBACK: "รอเจ้าหน้าที่ติดต่อกลับ",
  AWAITING_INTEREST_COMPARISON: "ขอพิจารณา / เปรียบเทียบดอกเบี้ย กับธนาคารอื่นๆ",
  AWAITING_DOCUMENT: "รอรับเอกสารประกอบการอนุมัติ",
  AWAITING_PRE_APPROVE: "รอผลการอนุมัติขั้นต้น",
  AWAITING_APPRAISE: "รอราคาประเมิน",
  AWAITING_FINAL_APPROVE: "รอผลการอนุมัติจริง",
  COMPLETED: "จดจำนอง",
  REJECTED: "ไม่ผ่านการอนุมัติ",
  NOT_INTERESTED: "ไม่สนใจใช้บริการ"
};

export const RefinanceStatusEnum = {
  AWAITING_FEEDBACK: "AWAITING_FEEDBACK",
  AWAITING_INTEREST_COMPARISON: "AWAITING_INTEREST_COMPARISON",
  AWAITING_DOCUMENT: "AWAITING_DOCUMENT",
  AWAITING_PRE_APPROVE: "AWAITING_PRE_APPROVE",
  AWAITING_APPRAISE: "AWAITING_APPRAISE",
  AWAITING_FINAL_APPROVE: "AWAITING_FINAL_APPROVE",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  NOT_INTERESTED: "NOT_INTERESTED"
};



// WEBPACK FOOTER //
// ./src/features/refinance/RefinanceStatus.js